module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-Regular.87e86330.ttf";